'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getConversionRecord;

var _utils = require('react-utils/utils');

var _ = require('_');

function getConversionRecord(recordList, ForcedRecordClass) {
  var conversionRecord = void 0;

  // make sure ForcedRecordClass matches
  if (ForcedRecordClass !== undefined) {
    var isMatchingType = (0, _.some)(recordList, function (recordClass) {
      return ForcedRecordClass === recordClass;
    });
    (0, _utils.invariant)(isMatchingType, 'event-tracking-tools: ForcedRecordClass must be one of "%s". Got "%s"', recordList, ForcedRecordClass.name);

    conversionRecord = ForcedRecordClass;
  } else {
    conversionRecord = recordList[0];
  }

  return conversionRecord;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/utils/getConversionRecord.js
// module id = 436
// module chunks = 0